import { SPECS } from '@/common/constants/specs';
import { getCampaignV1 } from '@/common/api/v1/getCampaign';
import { getCampaign } from '@/common/api/getCampaign';
import { RootStore } from '@/components/DonationForm/types';
import {
  DonationCampaignV1,
  GetDonationCampaignMetricsResponseV1,
  DonationCampaign,
  CurrencyMetrics,
} from '@/common/types';
import { getIsPremium } from '@/common/api/getIsPremium';
import {
  getDefaultCampaign,
  getDefaultCampaignV1,
} from '@/common/utils/defaultCampaign';
import { getMetricsV1 } from '@/common/api/v1/getMetrics';
import { getMetrics } from '@/common/api/getMetrics';
import { getCurrency } from '@/common/utils/currency';

export const getInitialData = async ({
  httpClient,
  experiments,
  $state,
  isV2,
  wixCodeApi,
}: RootStore) => {
  let campaignPromise:
    | Promise<DonationCampaignV1 | DonationCampaign | undefined>
    | undefined;
  const { campaignId } = $state;
  if (campaignId !== undefined) {
    campaignPromise = (isV2 ? getCampaign : getCampaignV1)(
      httpClient,
      campaignId,
    );
  } else if (experiments.enabled(SPECS.defaultCampaign)) {
    campaignPromise = (isV2 ? getDefaultCampaign : getDefaultCampaignV1)(
      httpClient,
    );
  }
  const [campaign, isPremium] = await Promise.all([
    campaignPromise,
    getIsPremium(httpClient),
  ]);

  let metrics:
    | GetDonationCampaignMetricsResponseV1
    | CurrencyMetrics
    | undefined;
  if (isV2) {
    const shouldFetchMetrics = !!(campaign as DonationCampaign)?.campaignGoal;
    if (shouldFetchMetrics) {
      metrics = await getMetrics(
        httpClient,
        campaign!.id!,
        getCurrency({ wixCodeApi }),
      );
    }
  } else {
    const shouldFetchMetrics = !!(campaign as DonationCampaignV1)
      ?.campaignGoalEnabled;
    if (shouldFetchMetrics) {
      metrics = await getMetricsV1(httpClient, campaign!.id!);
    }
  }

  return {
    campaign,
    isPremium,
    metrics,
  };
};
